






















import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import Home from '@/components/Home.vue';
import Insulation from '@/components/Insulation.vue';
import Ultraviolet from '@/components/Ultraviolet.vue';
import Signal from '@/components/Signal.vue';
import Dazzle from '@/components/Dazzle.vue';
import Warranty from '@/components/Warranty.vue';
import Environment from '@/components/Environment.vue';
import Selected from '@/components/Selected.vue';
import Enjoy from '@/components/Enjoy.vue';
import EnjoySafety from '@/components/EnjoySafety.vue';
import VehicleSafety from '@/components/VehicleSafety.vue';
import Load from '@/components/Load.vue';
import Series from '@/components/Series.vue';
import Menu from '@/components/Menu.vue';
@Component({
  components: {
    Home,
    Insulation,
    Ultraviolet,
    Signal,
    Dazzle,
    Warranty,
    Environment,
    Load,
    Series,
    Menu,
    VehicleSafety,
    EnjoySafety,
    Enjoy,
    Selected,
  },
  computed: mapState(['imgs', 'currentPage']),
})
export default class Index extends Vue {
  imgs!: Array<string>;

  currentPage!: string;

  onComplete() {
    this.$store.commit('setCurrentPage', 'Home');
    // this.$store.commit('setCurrentPage', 'Series');
  }

  created() {
    // this.$store.commit('setCurrentPage', 'series');
  }
}
